import { useBooking } from './booking';

export function Hero() {
  const { openBooking } = useBooking();
  return (
    <section id="top" className="relative flex min-h-[100svh] items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="/img/hero.webp"
          alt="A flowing blue gown catching the Aegean wind above the Santorini caldera"
          width={1920}
          height={1080}
          className="h-full w-full animate-slow-zoom object-cover object-[70%_center]"
          decoding="async"
          // Lowercase DOM attribute so it renders on React 18.x (camelCase
          // fetchPriority is only honored in React 19); pairs with the
          // <link rel="preload"> for the hero in index.html.
          {...{ fetchpriority: 'high' }}
        />
        {/* Aegean wash - darkens the left for legible type, fades to cream at the base */}
        <div className="absolute inset-0 bg-gradient-to-r from-navy-deep/85 via-navy-deep/45 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-deep/70 via-transparent to-navy-deep/20" />
      </div>

      {/* Content */}
      <div className="container-content section-pad relative z-10 pt-24">
        <div className="max-w-2xl">
          <p className="eyebrow text-crimson-soft animate-fade-up">Editorial Photography</p>
          <h1
            className="mt-6 font-display text-[clamp(2.75rem,7vw,5.25rem)] font-medium leading-[1.04] text-white animate-fade-up"
            style={{ animationDelay: '0.08s' }}
          >
            Where the dress
            <br />
            takes flight
          </h1>
          <p
            className="mt-6 max-w-md font-sans text-base font-light leading-relaxed text-white/85 animate-fade-up"
            style={{ animationDelay: '0.16s' }}
          >
            We turn a vacation into a high-fashion editorial - captured against the iconic
            white-washed cliffs of the caldera.
          </p>
          <div
            className="mt-9 flex flex-wrap items-center gap-4 animate-fade-up"
            style={{ animationDelay: '0.24s' }}
          >
            <button
              type="button"
              onClick={() => openBooking(undefined, undefined, 'hero')}
              className="btn btn-primary"
            >
              Book Your Experience
            </button>
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-7 left-1/2 z-10 hidden -translate-x-1/2 sm:block">
        <span className="block h-12 w-px animate-pulse bg-white/50" />
      </div>
    </section>
  );
}
